import { Form, useForm } from '@/components/forms';
import Input from '@/components/forms/Input';
import { useDynamicLocale } from '@/hoslog-intl';
import { z } from 'zod';
import useManageReferralStage from './hooks/useManageReferralStage';

const positiveNumberSchema = z
  .string()
  .min(1, { message: 'common.form.validation.required' })
  .regex(/^\d+$/, { message: 'common.form.validation.invalid' })
  .refine((val) => Number(val) >= 0, { message: 'common.form.validation.invalid' });

const referralStageTwoSchema = z.object({
  stageTitle: z.string().min(1, { message: 'common.form.validation.required' }),
  stageTwoRewardPoint: positiveNumberSchema,
});

export const ManageReferralStageTwo = ({
  defaultValues,
  stageId,
}: {
  defaultValues: { stageTitle: string; stageTwoRewardPoint: string };
  stageId: string;
}) => {
  const form = useForm({ schema: referralStageTwoSchema, mode: 'onBlur', defaultValues });
  const { t } = useDynamicLocale();
  const { mutateAsync } = useManageReferralStage();

  return (
    <Form
      form={form}
      onSubmit={async (data) => {
        const payload = {
          stageId,
          stageTitle: data.stageTitle,
          totalRewardForAllVisit: data.stageTwoRewardPoint,
          firstVisitRewardPoint: '',
          secondVisitRewardPoint: '',
          thirdVisitRewardPoint: '',
        };
        await mutateAsync(payload);
      }}
      fieldsetClassName="space-y-[18px]"
    >
      <Input
        label="pointManagement.pointsConfiguration.manageReferralStageTwo.label.stageTitle"
        placeholder={t('pointManagement.pointsConfiguration.manageReferralStageTwo.placeholder.stageTitle')}
        {...form.register('stageTitle')}
        maxLength={6}
        forceRequired
        disabled
      />
      <Input
        label="pointManagement.pointsConfiguration.manageReferralStageTwo.label.tenVisitReward"
        placeholder={t('pointManagement.pointsConfiguration.manageReferralStageTwo.placeholder.tenVisitReward')}
        {...form.register('stageTwoRewardPoint')}
        onlyNumbers
        maxLength={6}
        forceRequired
      />
    </Form>
  );
};
